.container {
    align-self: flex-start;
    display: grid;
    grid-template-columns: 3fr 1fr;
    gap: 16px;
    width: 100%;
    padding: 16px;
    overflow: auto;
}
